import type { GroupPreviewType, PreviewData } from 'models';
import { useTranslation } from 'react-i18next';
import { DataCard } from 'ui';
import { images } from 'common/utils';
import { useGetGroupPreviewIcon, useGetGroupPreviewTypeName } from '../../../hooks';

export type PreviewEntityType = 'group' | 'organization';

type P = {
  data: PreviewData;
  getPathToDetail: (id: string, options: { entityType: PreviewEntityType }) => string;
  showTag?: boolean;
  type: GroupPreviewType;
};

const PreviewCard = ({ data, getPathToDetail, showTag = true, type }: P) => {
  const { t } = useTranslation();
  const getGroupPreviewTypeName = useGetGroupPreviewTypeName();
  const getGroupPreviewIcon = useGetGroupPreviewIcon();

  const defaultPhoto =
    type === 'organization'
      ? { alt: 'Organization cover photo', src: images.default.organizationCoverPhoto }
      : { alt: 'Group cover photo', src: images.default.groupCoverPhoto };

  return (
    <DataCard
      image={{
        alt: defaultPhoto.alt,
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        src: data.coverPhoto?.url ?? defaultPhoto.src,
      }}
      participantsProperties={{
        count: data.usersCount,
        label: (formattedMembersCount) =>
          t('formattedMembersCount', { count: data.usersCount, formattedCount: formattedMembersCount }),
      }}
      path={getPathToDetail(data.id, { entityType: type === 'organization' ? 'organization' : 'group' })}
      tag={
        showTag
          ? { children: getGroupPreviewTypeName({ groupType: type }), icon: getGroupPreviewIcon({ groupType: type }) }
          : undefined
      }
      title={data.name}
    />
  );
};

export default PreviewCard;
